import { PAGE_TYPES } from "@constants/pageTypes";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";

export const trackComparisonPageView = (additionalProps: Record<string, string>) => {
  void trackEventWithCommonProps("view", EventType.PAGE_EVENT, {
    pageType: PAGE_TYPES.COMPARISON_PAGE,
    additionalProps: {
      view_type: "view_page",
      view_name: "view_comparison_page",
      ...additionalProps,
    },
  });
};

let lastComparisonAction: { key: string; at: number } | null = null;

export const trackComparisonAction = (
  actionName: string,
  additionalProps: Record<string, string> = {}
) => {
  const key = `${actionName}|${JSON.stringify(additionalProps)}`;
  const now = Date.now();

  if (lastComparisonAction?.key === key && now - lastComparisonAction.at < 500) {
    return;
  }
  lastComparisonAction = { key, at: now };

  void trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
    pageType: PAGE_TYPES.COMPARISON_PAGE,
    additionalProps: {
      action_type: "tap_btn",
      action_name: actionName,
      ...additionalProps,
    },
  });
};
